import * as React from 'react';

import {colors} from '../colors/colors';
import {Body} from '../typography/body';

import styles from './chat-action-button.module.css';

type Props = {
    label: string;
    icon: React.ComponentType<any>;
    isSelected: boolean;
};

export function ChatActionButton(props: Props) {
    const Icon = props.icon;

    return (
        <button className={styles['chat-action-button']}>
            <Icon size={18} color={colors.white} opacity={props.isSelected ? 1 : 0.7} />
            <Body size='small' color='white'>
                {props.label}
            </Body>
        </button>
    );
}
